import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { DataService } from "../services/data/data.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(
    private dataService: DataService,
    private router: Router,
  ) {}

  canActivate(): boolean {
    if (this.dataService.getToken()) {
      // console.log("Token:", this.dataService.getToken());
      return true;
    } else {
      console.log("Token does not exist, navigating to login");
      this.router.navigate(["/auth/login2"]);
      return false;
    }
  }
}
